export function extractUserGroup(rawUserGroup: $TSFixMe) {
  const userGroup = {
    id: rawUserGroup.id,
    name: rawUserGroup.name,
    description: rawUserGroup.description,
  };
  return userGroup;
}

export function extractUserGroups(rawUserGroups: $TSFixMe) {
  return rawUserGroups.usergroups.map((userGroup: $TSFixMe) =>
    extractUserGroup(userGroup),
  );
}

export function extractUserForUserGroup(rawUser: $TSFixMe) {
  const user = {
    id: rawUser.id,
    firstName: rawUser.first_name,
    lastName: rawUser.last_name,
  };
  return user;
}

export function extractUserGroupUsers(rawUserGroupUsers: $TSFixMe) {
  return rawUserGroupUsers.users.map((user: $TSFixMe) =>
    extractUserForUserGroup(user),
  );
}
